module.exports = __webpack_public_path__ + "static/media/allalerts.1df2aaa4.svg";